// @flow

import type {
  UserOperationsById,
} from 'fc-operator-user/types'

// Libs
import React, { Component } from 'react'

// Components
import Button from '@react-mdc/button'
import { Errors } from 'hfty-components-errors'
import Mask from 'fc-masks'

// Styles
import { black } from 'hfty-styles/src/colors'
import { sidebar as sidebarCommonStyle } from 'hfty-styles/src/common'
const sidebar = sidebarCommonStyle

const styles = {
  message: {
    padding: 20,
    color: black(),
  },
}

type Props = {
  operations: Array<UserOperationsById>,
  onCancel: Function,
  onSubmit: Function,
}

export default class DeleteUsers extends Component {
  props: Props
  onSubmit: Function
  onCancel: Function

  constructor (props: Props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.renderDeleteConfirmation = this.renderDeleteConfirmation.bind(this)
  }

  onSubmit (e: Event) {
    e.preventDefault()

    this.props.onSubmit(this.props.operations)
  }

  onCancel (e: Event) {
    e.preventDefault()

    this.props.onCancel(this.props.operations)
  }

  renderDeleteConfirmation (): React.Element<any> {
    let msg = this.props.operations.length > 1
      ? 'Are you sure you want to delete these users?'
      : 'Are you sure you want to delete this user?'

    return (
      <div style={sidebar.container}>
        <form>
          <Errors errors={this.props.operations.errors} labels={['error']} />
          <div style={styles.message}>{msg}</div>
          <div style={sidebar.buttonWrapper}>
            <Button
              raised
              primary
              style={sidebar.button}
              onClick={this.onSubmit}
            >
              {'Submit'}
            </Button>
            <Button
              raised
              onClick={this.onCancel}
            >
              {'Cancel'}
            </Button>
          </div>
        </form>
        <Mask enabled={this.props.operations.submitting} />
      </div>
    )
  }

  render (): ?React.Element<any> {
    if (!this.props.operations.length) {
      return null
    }

    return this.renderDeleteConfirmation()
  }
}
